var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "person-auth-root" }, [
    _c("div", { staticClass: "box" }, [
      _c("div", { staticClass: "step-box" }, [
        _c("div", { staticClass: "font-family font-21 step1" }, [
          _vm._v("01基本信息")
        ]),
        _c(
          "div",
          {
            staticClass: "font-family font-21",
            class: {
              "un-start": _vm.authStep == 1,
              doing: _vm.authStep > 1
            }
          },
          [_vm._v("02选择认证方式")]
        ),
        _c(
          "div",
          {
            staticClass: "font-family font-21",
            class: {
              "un-start": _vm.authStep < 3,
              doing: _vm.authStep == 3
            }
          },
          [_vm._v(_vm._s(_vm.approveStatus == 0 ? "03人工审核" : "03认证完成"))]
        )
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.authStep == 1,
              expression: "authStep == 1"
            }
          ]
        },
        [
          _c(
            "div",
            { staticClass: "info-box" },
            [
              _c(
                "el-form",
                {
                  ref: "authForm",
                  attrs: {
                    model: _vm.enterprise,
                    rules: _vm.enterpriseRules,
                    "label-position": "left",
                    "label-width": "150px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "企业名称：", prop: "enterpriseName" } },
                    [
                      _c("el-input", {
                        staticClass: "input-width",
                        attrs: {
                          placeholder: "请输入企业名称",
                          readonly: _vm.isInDingTalk
                        },
                        model: {
                          value: _vm.enterprise.enterpriseName,
                          callback: function($$v) {
                            _vm.$set(_vm.enterprise, "enterpriseName", $$v)
                          },
                          expression: "enterprise.enterpriseName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "用户名：", prop: "email" } },
                    [
                      _c("el-input", {
                        staticClass: "input-width",
                        attrs: { placeholder: "请输入邮箱号码" },
                        model: {
                          value: _vm.enterprise.email,
                          callback: function($$v) {
                            _vm.$set(_vm.enterprise, "email", $$v)
                          },
                          expression: "enterprise.email"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "验证码：", prop: "code_copy" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "input-width",
                          attrs: {
                            "auto-complete": "off",
                            placeholder: "输入验证码"
                          },
                          model: {
                            value: _vm.enterprise.code_copy,
                            callback: function($$v) {
                              _vm.$set(_vm.enterprise, "code_copy", $$v)
                            },
                            expression: "enterprise.code_copy"
                          }
                        },
                        [
                          _c("template", { slot: "append" }, [
                            _c(
                              "span",
                              {
                                staticClass: "img-code",
                                on: { click: _vm.getImgCode }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src:
                                      "data:image/png;base64," +
                                      _vm.imgAuth.imgPath
                                  }
                                })
                              ]
                            )
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.authStep == 2,
              expression: "authStep == 2"
            }
          ],
          staticClass: "stpe-mainland"
        },
        [
          !_vm.showAuthList
            ? _c("div", { staticClass: "auth-box" }, [
                _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        return _vm.handAuthList(1)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "auth-type",
                        class: _vm.authType === 1 ? "red-border" : ""
                      },
                      [
                        _c("img", {
                          attrs: { src: "/images/add_now2.png", alt: "" }
                        }),
                        _c("p", { staticClass: "font-title" }, [
                          _vm._v("快速认证")
                        ])
                      ]
                    ),
                    _c("p", [_vm._v("使用君子签SaaS已有帐号进行认证")])
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "auth-type",
                    class: _vm.authType === 2 ? "red-border" : "",
                    on: {
                      click: function($event) {
                        return _vm.handAuthList(2)
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: { src: "/images/add_now2.png", alt: "" }
                    }),
                    _c("p", { staticClass: "font-title" }, [_vm._v("在线认证")])
                  ]
                )
              ])
            : _vm._e(),
          _vm.showAuthList
            ? _c("div", [
                _c("p", { staticClass: "font-title" }, [_vm._v("快速认证：")]),
                _c(
                  "div",
                  { staticClass: "list-box" },
                  _vm._l(_vm.accontList, function(item) {
                    return _c(
                      "div",
                      {
                        key: item.emailSec,
                        staticClass: "auth-list",
                        class:
                          _vm.selectAccont.emailSec === item.emailSec
                            ? "active-auth"
                            : "",
                        on: {
                          click: function($event) {
                            return _vm.chooseAccont(item)
                          }
                        }
                      },
                      [
                        _c("p", [_vm._v("企业名称：" + _vm._s(item.name))]),
                        _c("p", [
                          _vm._v(
                            "统一社会信用代码：" + _vm._s(item.business_license)
                          )
                        ]),
                        _c("p", [_vm._v("账号：" + _vm._s(item.email))])
                      ]
                    )
                  }),
                  0
                )
              ])
            : _vm._e()
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.authStep == 3,
              expression: "authStep == 3"
            }
          ],
          staticClass: "stpe-end"
        },
        [
          _vm.authentication !== 4
            ? _c("div", { staticClass: "res-icon" }, [
                _vm.approveStatus == 0
                  ? _c("div", [
                      _c("img", {
                        attrs: {
                          src: "/images/auth/authIcon/clock.png",
                          alt: ""
                        }
                      }),
                      _c("p", { staticClass: "text" }, [
                        _vm._v("正在审核中，请耐心等待")
                      ]),
                      _c("p", { staticClass: "text" }, [
                        _vm._v("您还可以拨打4008089187联系人工审核")
                      ])
                    ])
                  : _c("div", [
                      _c("img", {
                        attrs: { src: "/images/auth/authIcon/suc.png", alt: "" }
                      }),
                      _c("p", { staticClass: "text" }, [_vm._v("实名认证成功")])
                    ])
              ])
            : _vm._e()
        ]
      ),
      _c("div", { staticClass: "step-btn" }, [
        _c(
          "div",
          { staticStyle: { "margin-top": "10px" } },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.authStep == 2,
                    expression: "authStep == 2"
                  }
                ],
                attrs: { type: "danger", plain: "" },
                on: { click: _vm.previous }
              },
              [_vm._v("上一步")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.authStep == 1,
                    expression: "authStep == 1"
                  }
                ],
                attrs: { type: "danger" },
                on: { click: _vm.authSubmit }
              },
              [_vm._v("立即绑定")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.authStep == 3,
                    expression: "authStep == 3"
                  }
                ],
                attrs: { type: "danger" },
                on: { click: _vm.confirm }
              },
              [_vm._v("完成")]
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56825a83", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56825a83","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/dingtalkUse/authentication.vue
// module id = JPh3
// module chunks = 195